import { clientApi } from 'api';
import { ICatalogue } from 'server/models/Catalogue/types';

export const getHomeProducts = (isServer = false) => async () => {
  const response = await clientApi.get<ICatalogue[]>('/home-products');

  return response;
};
